// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1StateSchema } from './v1/stateSchema';
import { v1StatesCreateSchema } from './v1/states/createSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const createHourStatePathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const createHourStateHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description State created
 */
export const createHourState201Schema = z.lazy(() => v1StateSchema);

/**
 * @description Unauthorized
 */
export const createHourState401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Validation errors
 */
export const createHourState422Schema = z.lazy(() => v1ValidationErrorSchema);

export const createHourStateMutationRequestSchema = z.lazy(() => v1StatesCreateSchema);

export const createHourStateMutationResponseSchema = z.lazy(() => createHourState201Schema);
